export enum ServiceTypeEnum {
  EQUIPMENT = 'Equipment',
  INTERNAL = 'Internal',
  NEXT_FLIGHT_OUT = 'Next Flight Out',
  ORGAN = 'Organ',
  SPECIMEN = 'Specimen',
  TEAM = 'Team',
  HAND_CARRY = 'Hand Carry',
}
